import {styled} from "@mui/material/styles";
import {DialogActions} from "@mui/material";
import {DataGrid} from "@mui/x-data-grid";

export const dataGridHorizontalScrollSx = (theme) => ({
    width: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    "&::-webkit-scrollbar": {
        height: "12px",
        backgroundColor: "transparent",
    },
    "&::-webkit-scrollbar-track": {
        backgroundColor: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
        background: "transparent",
        borderRadius: "6px",
        border: "3px solid transparent",
        backgroundClip: "content-box",
    },
    "&:hover::-webkit-scrollbar-thumb": {
        background: `${theme.palette.secondary.main} !important`,
        backgroundColor: `${theme.palette.secondary.main} !important`,
        border: "3px solid transparent !important",
        borderRadius: "6px",
        backgroundClip: "content-box",
    },
    "&::-webkit-scrollbar-thumb:hover": {
        background: `${theme.palette.secondary.focus} !important`,
        backgroundColor: `${theme.palette.secondary.focus} !important`,
        border: "0 !important",
    },
});

export const MuiDataGrid = styled(DataGrid)(({ theme }) => ({
    color: theme.palette.text.mui,
    boxShadow: 2,
    border: 'none',
    fontSize:'small',
    fontWeight:'normal',
    textAlign: 'center',
    '& .MuiDataGrid-cell:hover': {
        color: theme.palette.primary.light,
        cursor: 'pointer'
    },
    '& .MuiDataGrid-cell:focus': {
        outlineColor: theme.palette.primary.light,
        border:2,
        shadow:''
    },
    '& .MuiToolbar-root':{
        color:theme.palette.text.main,
        fontSize: 'small',
        fontWeight: 700,
    },
    '& .MuiTablePagination-selectLabel':{
        fontSize: 'small',
        fontWeight: 700
    },
    '& .MuiSelect-select': {
        fontSize: 'small',
        fontWeight: 700
    },
    '& .MuiTablePagination-displayedRows': {
        fontSize: 'small',
        fontWeight: 700
    },
    '& .MuiDataGrid-columnsPanelRow': {
        color:theme.palette.text.main,
        backgroundColor: theme.palette.info.light,
    },

    // '& .MuiIcon-root':{
    //     color:'red'
    // },

    '& .MuiDataGrid-columnHeaders':{
        backgroundColor: theme.palette.background.default,
        color:theme.palette.primary.main,
        boxShadow: 'rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px'

    },
    '& .MuiDataGrid-columnHeaderTitle':{
        color:theme.palette.primary.main,
        fontWeight:'bold'
    },
    '& .MuiDataGrid-columnHeaderTitleContainerContent':{
        color:theme.palette.primary.main,
        fontWeight:'bold'
    },




    "& .MuiDataGrid-cell": {
        border: `1px solid ${theme.palette.background.default}`,
        // whiteSpace: 'normal !important',
        // wordWrap: 'break-word !important',
        // lineHeight: 'unset !important',
        // maxHeight: 'none !important',
        // whiteSpace: 'normal',
    },


    '& .MuiDataGrid-row': {
        maxHeight: 'none !important',
    },

    '& .MuiDataGrid-renderingZone': {
        maxHeight: 'none !important',
    },

    "& .MuiDataGrid-iconButtonContainer ": {
        button:{
            color: theme.palette.text.primary,
        }
    },


    "& .MuiDataGrid-menuIcon": {
        button:{
            color: theme.palette.text.primary
        }
    },

    " .MuiDataGrid-scrollbar": {
        backgroundColor: 'transparent !important',
        scrollbarColor: 'transparent transparent'
    },

    " .MuiDataGrid-scrollbar *": {
        backgroundColor: 'transparent !important'
    },

    " .MuiDataGrid-scrollbar::-webkit-scrollbar": {
        backgroundColor: 'transparent !important'
    },

    " .MuiDataGrid-scrollbar::-webkit-scrollbar-track": {
        backgroundColor: 'transparent !important'
    },

    " .MuiDataGrid-scrollbar::-webkit-scrollbar-corner": {
        backgroundColor: 'transparent !important'
    },

    " .MuiDataGrid-scrollbar::-webkit-scrollbar-thumb": {
        backgroundColor: 'transparent !important',
        border: '3px solid transparent',
        backgroundClip: 'content-box'
    },

    "&:hover .MuiDataGrid-scrollbar::-webkit-scrollbar-thumb": {
        backgroundColor: `${theme.palette.secondary.main} !important`
    },

    " .MuiDataGrid-scrollbar::-webkit-scrollbar-thumb:hover": {
        backgroundColor: `${theme.palette.secondary.focus} !important`,
        border: '0'
    },

    " .MuiDataGrid-scrollbar--horizontal": {
        left:0,
        height:'12px',
        backgroundColor: 'transparent !important'
    },

    " .MuiDataGrid-scrollbar--vertical": {
        width:'12px',
        backgroundColor: 'transparent !important'
    },

    " .MuiDataGrid-scrollbarFiller": {
        backgroundColor: 'transparent !important'
    },

    " .MuiDataGrid-filler": {
        backgroundColor: 'transparent !important'
    },

    "&:hover .MuiDataGrid-scrollbar--horizontal": {
        height:'12px'
    },

    "&:hover .MuiDataGrid-scrollbar--vertical": {
        width:'12px'
    },

    '& ::-webkit-scrollbar':{
        width: '12px',
        height: '12px',
        left:0,
        backgroundColor: 'transparent !important'
    },
    '&:hover ::-webkit-scrollbar':{
        width: '12px',
        height: '12px',
        left:0
    },
    '& ::-webkit-scrollbar-track':{
        backgroundColor: 'transparent !important'
    },
    '& ::-webkit-scrollbar-corner':{
        backgroundColor: 'transparent !important'
    },
    '& ::-webkit-scrollbar-thumb': {
        background: 'transparent',
        borderRadius: '6px',
        border: '3px solid transparent',
        backgroundClip: 'content-box'
    },
    '&:hover ::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.secondary.main
    },
    '& ::-webkit-scrollbar-thumb:hover ':{
        backgroundColor: theme.palette.secondary.focus,
        border: '0'
    },

}));
